import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private apiUrl = environment.apiUrl + '/api'; // Your backend API URL

  constructor(
    private http: HttpClient,
    private router: Router,
    private cookieService: CookieService
  ) {}

  async fetchToken() {
    return this.http
      .get<{ token: string }>(`${this.apiUrl}/auth/get-token`, {
        withCredentials: true,
      })
      .subscribe({
        next: (response) => {
          this.cookieService.set('user', response.token);
          return response.token;
        },
        error: (err) => {
          console.error('Error fetching token:', err);
        },
      });
  }

  checkLogin() {
    const userId = this.cookieService.get('user');
    if (!userId) {
      document.location.href = 'https://queryai.co.uk';
      return;
    }

    this.http
      .get(`${this.apiUrl}/auth/validate-user?user_id=${userId}`, {
        withCredentials: true,
      })
      .subscribe({
        next: (response: any) => {
          if (!response.valid) {
            document.location.href = 'https://queryai.co.uk';
          }
        },
        error: () => {
          document.location.href = 'https://queryai.co.uk';
        },
      });
  }

  logout(): void {
    this.cookieService.delete('user', '/', 'queryai.co.uk');
    this.router.navigate(['/login']);
  }

  // Retrieve token from localStorage
  getToken(): string | null {
    return this.cookieService.get('user');
  }

  getAuthHeaders(): HttpHeaders {
    document;
    const userId = this.cookieService.get('user');
    return new HttpHeaders({
      Authorization: `Bearer ${userId}`,
    });
  }

  storeToken(token: string): void {
    localStorage.setItem('token', token);
  }

  storeUserCookie(userId: string): void {
    this.cookieService.set('user', userId, {
      path: '/',
      domain: 'queryai.co.uk',
      secure: true,
      sameSite: 'None',
    });
  }

  getUserTokens(): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/token/tokenCount`, {
      headers: this.getAuthHeaders(),
    });
  }

  idFromToken(): string {
    const token = localStorage.getItem('token');
    if (token) {
      const payload = JSON.parse(atob(token.split('.')[1]));
      return payload.id;
    }
    return '';
  }

  getDashboardStats(): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/dashboard`, {
      headers: this.getAuthHeaders(),
    });
  }
}
